<template>
    <div class="comments">
        <div class="comments-list">
            <Comment
                v-for="comment in comments"
                :key="comment.id"
                :comment="comment"
                class="mb-2"
            />
        </div>
    </div>
</template>

<script>

import Comment from './Comment';

export default {
    name: 'Comments',

    components: {
        Comment,
    },

    props: {
        comments: {
            type: Array,
            required: false,
            default: [],
        },
    },
}
</script>
